import { init } from '../../../home24-shared/tracking/layout/logout';
import { register } from '../../core/bootstrapper';

register(null, () => {
  init();
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/layout/trackingBootstrap.js
 **/